module.exports = __webpack_public_path__ + "media/track_guides/tips_banner-bc0cb020.png";